import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  auth: null,
  user: null,
  postsLoaded: false,
  posts: [],
  unreadNotifications: [],
  targetRoute: null,
  globalNotification: null,
};


/* eslint-disable no-new */
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js